import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import eventsData from "../../data/UpcomingEventsData.json";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./UpcomingEventsSection.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import AddUpcomingEvents from "../AddEventFolder/AddUpcomingEvents";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { allowedPeople, baseUrl } from "../../Constants";
import { useMsal } from "@azure/msal-react";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";

const EventCarousel = () => {
  const [events, setEvents] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [itemsToDelete, setitemsToDelete] = useState();
  const [confirmationPopup, setconfirmationPopup] = useState(false);
  const [addUpcomingEventPopup, setaddUpcomingEventPopup] = useState(false);
  const [UpcomingEventsState, setUpcomingEventsState] = useState();
  const sliderRef = useRef(null);
  const thumbnailContainerRef = useRef(null);

  //fetching User

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  let loggedInEnterpriseId = "";
  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;

  const deleteItem = async (id) => {
    try {
      const res = await axios.post(
        `${baseUrl}/deleteUpcomingEventData`,
        { id },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      );
      getUpcomingEvents();
    } catch (err) {
      console.error(err);
    }
  };

  const getUpcomingEvents = () => {
    axios
      .get(`${baseUrl}/getupcomingevent`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setUpcomingEventsState(response.data.results); // Set the data
        console.log("getupcomingeventResponse", response);
      })
      .catch((error) => {
        console.log(error);
        console.log("getupcomingevent", error);
      });
  };

  useEffect(() => {
    console.log("workinggg....");

    getUpcomingEvents();
  }, [addUpcomingEventPopup]);

  useEffect(() => {
    setEvents(eventsData);
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 2000,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    arrows: false,
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
  };

  const formatDate = (rawDate) => {
    // const rawDate = event[`explore_date_${index}`];

    // Format the date if it exists
    const formattedDate = rawDate
      ? new Date(rawDate).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
      : "";
    return formattedDate;
  };

  const scrollThumbnails = (direction) => {
    const container = thumbnailContainerRef.current;
    if (container) {
      const scrollAmount = container.clientWidth;
      container.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="event-carousel">
      <Slider ref={sliderRef} {...settings}>
        {/* {events.map((event) => ( */}
        {UpcomingEventsState &&
          UpcomingEventsState.map((event) => (
            <div key={event.id} className="event-slide-wrap">
              {/* <div className="event-slide-row row2" data-aos="fade-right"> */}
              <div className="event-slide-row row2">
                <div className="event-slide-box">
                  <div className="heading-box">
                    <h2 className="main-headings">Upcoming Events</h2>
                    {allowedPeople.includes(loggedInEnterpriseId) && (
                      <button
                        type="button"
                        onClick={() => {
                          setaddUpcomingEventPopup(true);
                        }}
                        className="add-prog-button"
                      >
                        <AddIcon />
                        Add Program
                      </button>
                    )}
                  </div>
                  <p className="section-subtext">{event.short_des}</p>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <h3 className="main-headings">{event.title}</h3>
                    {/* <DeleteRoundedIcon
                      sx={{
                        color: "gray",
                        display: "inline",
                        cursor: "pointer",
                        width: "1em",
                        height: "1em",
                        marginInline: "18px",
                        fontSize: "1.2rem",
                      }}
                      onClick={() => {
                        setconfirmationPopup(true);
                        setitemsToDelete(event.id);
                      }}
                    /> */}
                    <img
                      src={
                        process.env.PUBLIC_URL + "/images/Home/delete-icon.png"
                      }
                      alt="icon"
                      className="upcoming-delete-icon"
                      onClick={() => {
                        setconfirmationPopup(true);
                        setitemsToDelete(event.id);
                      }}
                    />
                  </div>
                  {/* <h3 className="main-headings">{event.title}</h3> */}
                  {/* <p>{event.content}</p> */}

                  {
                    // event.join_event_url &&
                    true && (
                      <>
                        <p>{event.event_content}</p>
                        <div
                          className="event-where-when-box1"
                          // className={
                          //   event.id === 3
                          //     ? "event-where-when-box1"
                          //     : "event-where-when-box"
                          // }
                        >
                          {/* {event.id === 3 ? (
                    ""
                  ) : ( */}
                          {/* )} */}
                          {/* {event.id === 3 ? ( */}
                          <>
                            {event.location && !event.explore_0 && (
                              <p className="where-text">
                                <span>Where</span> <br />
                                <span className="location-details">
                                  {event.location}
                                </span>
                              </p>
                            )}
                            {event.date && (
                              <p className="when-text">
                                <span>When</span> <br />{" "}
                                <span className="date-box">
                                  {" "}
                                  <strong> {event.onlydate} </strong>{" "}
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: formatDate(event.date),
                                    }}
                                  ></span>{" "}
                                </span>
                              </p>
                            )}
                          </>
                          {/* ) : (
                    ""
                  )} */}
                          {/* <div
                  className={
                    event.id === 3
                      ? "event-where-when-box1"
                      : "event-where-when-box"
                  }
                >
                  {event.id !== 3 && (
                    <p className="explore-text">
                      <span>Explore</span> <br />
                      <span
                        className="explore-details"
                        dangerouslySetInnerHTML={{ __html: event.explore }}
                      />
                    </p>
                  )}
                  {event.id === 3 && (
                    <>
                      <p className="where-text">
                        <span>Where</span> <br />
                        <span className="location-details">{event.where}</span>
                      </p>
                      <p className="when-text">
                        <span>When</span> <br />
                        <span className="date-box">
                          <strong>{event.onlydate}</strong>{" "}
                          <span
                            dangerouslySetInnerHTML={{ __html: event.date }}
                          />
                        </span>
                      </p>
                    </>
                  )} */}
                        </div>
                        {event.join_event_url && (
                          <p className="join-event">
                            <a
                              href={event.join_event_url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Join This Event
                            </a>
                          </p>
                        )}
                        {/* <p className="join-event">
                  {event.id === 1 ? (
                    <span className="join-disabled">
                      Join This Event (Unavailable)
                    </span>
                  ) : (
                    <a
                      href={event.join_event_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Join This Event
                    </a>
                  )}
                </p> */}
                      </>
                    )
                  }

                  {event.explore_0 && (
                    <p className="explore-text">
                      <span>Explore</span> <br />
                      <span
                        className="explore-details"
                        // dangerouslySetInnerHTML={{ __html: event.explore }}
                      >
                        {Array(6)
                          .fill()
                          .map((_, index) => {
                            return (
                              <p key={index}>
                                <a href={event[`explore_${index}`]}>
                                  {" "}
                                  {event[`explore_title_${index}`]}{" "}
                                </a>{" "}
                                <br />
                                {formatDate(event[`date_${index}`])}
                              </p>
                            );
                          })}

                        {/* <p><a href='https://wd103.myworkday.com/accenture/email-universal/inst/15972$36257/rel-task/2998$26720.htmld'> GenAI in Testing - <br/> Introduction </a> <br/>16-Jul-2025</p>  
                          <p><a href='https://wd103.myworkday.com/accenture/email-universal/inst/15972$36258/rel-task/2998$26720.htmld'>Performance Testing <br/>using Gen AI</a><br/>18-Jul-2025</p>  
                          <p><a href='https://wd103.myworkday.com/accenture/email-universal/inst/15972$36553/rel-task/2998$26720.htmld'>ETL Testing using <br/>Gen AI</a><br/>21-Jul-2025</p>  
                          <p><a href='https://wd103.myworkday.com/accenture/email-universal/inst/15972$36485/rel-task/2998$26720.htmld'>UI Testing using <br/>Gen AI</a><br/>23-Jul-2025</p> 
                          <p><a href='https://wd103.myworkday.com/accenture/email-universal/inst/15972$36357/rel-task/2998$26720.htmld'>API Testing using <br/>Gen AI</a><br/>25-Jul-2025</p> 
                          <p><a href='https://wd103.myworkday.com/accenture/email-universal/inst/15972$36600/rel-task/2998$26720.htmld'>Accessibility Testing <br/>using Gen AI</a><br/>28-Jul-2025</p> */}
                      </span>
                    </p>
                  )}

                  <p
                    className="pls-note"
                    dangerouslySetInnerHTML={{ __html: event.note }}
                  />
                </div>
              </div>
              {/* <div className="event-slide-row row1" data-aos="fade-left"> */}
              <div className="event-slide-row row1">
                <div className="event-slide-box">
                  <img
                    src={event.image_url}
                    alt={event.title}
                    // src={event.imageUrl}
                    className="event-img"
                  />
                </div>
              </div>
            </div>
          ))}
      </Slider>

      {/* Thumbnail navigation */}
      <div className="thumbnail-navigation-wrapper">
        <button
          className="thumbnail-arrow left-arrow"
          onClick={() => scrollThumbnails("left")}
          aria-label="Scroll thumbnails left"
        >
          <FaArrowLeft />
        </button>

        <div className="thumbnail-container" ref={thumbnailContainerRef}>
          {UpcomingEventsState &&
            UpcomingEventsState.map((event, index) => {
              // {events.map((event, index) => {
              const isActive =
                event.title === UpcomingEventsState[currentSlide]?.title;

              return (
                <div
                  key={event.title}
                  className={`thumbnail-item ${isActive ? "active" : ""}`}
                  onClick={() => sliderRef.current?.slickGoTo(index)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      sliderRef.current?.slickGoTo(index);
                    }
                  }}
                >
                  <div className="thumbnail-title">{event.title}</div>
                  {/* <img
                  src={event.thumbnail}
                  alt={event.title}
                  className="thumbnail-image"
                  loading="lazy"
                /> */}
                </div>
              );
            })}
        </div>

        <button
          className="thumbnail-arrow right-arrow"
          onClick={() => scrollThumbnails("right")}
          aria-label="Scroll thumbnails right"
        >
          <FaArrowRight />
        </button>
      </div>

      {/* Full-Screen Popup Modal */}
      {addUpcomingEventPopup && (
        <div className="fullscreen-popup">
          {/* <div className="popup-content"> */}

          <AddUpcomingEvents
            setaddUpcomingEventPopup={setaddUpcomingEventPopup}
            getUpcomingEvents={getUpcomingEvents}
          />

          {/* <Link to="/response" className="confirm" onClick={confirmSubmit}>Yes, Submit</Link>
                        <button className="cancel" onClick={closePopup}>Cancel</button> */}
          {/* </div> */}
        </div>
      )}

      {/* Full-Screen Popup Modal */}
      {confirmationPopup && (
        <div className="fullscreen-popup">
          <div className="popup-content">
            <div className="questions">Are you sure you want to submit?</div>
            <p>Once submitted, you cannot change your answers.</p>
            <div className="popup-buttons">
              <button
                className="confirm"
                onClick={() => {
                  deleteItem(itemsToDelete);
                  setconfirmationPopup(false);
                  setCurrentSlide(0);
                }}
              >
                Yes, delete!
              </button>
              <button
                className="cancel"
                onClick={() => setconfirmationPopup(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EventCarousel;
